export const GOOGLE_OAUTH_CALLBACK_CHANNEL_ID = 'oauth/google/callback';
export const GOOGLE_OAUTH_CALLBACK_ACTION = 'oauth/google/callback';

export type GoogleOAuthCallbackPayload = {
	code: string;
	state: string;
};

export type GoogleOAuthCallbackMessage = {
	action: typeof GOOGLE_OAUTH_CALLBACK_ACTION;
	payload: GoogleOAuthCallbackPayload;
};

/** Notifies the opener window (and other same-origin tabs) that Google OAuth finished in the popup. */
export function notifyGoogleOAuthCallback(payload: GoogleOAuthCallbackPayload) {
	const message: GoogleOAuthCallbackMessage = {
		action: GOOGLE_OAUTH_CALLBACK_ACTION,
		payload,
	};

	if (window.opener && !window.opener.closed) {
		window.opener.postMessage(message, window.location.origin);
	}

	const channel = new BroadcastChannel(GOOGLE_OAUTH_CALLBACK_CHANNEL_ID);
	channel.postMessage(message);
	channel.close();
}

export function listenGoogleOAuthCallback(listener: (payload: GoogleOAuthCallbackPayload) => void) {
	const onWindowMessage = (event: MessageEvent) => {
		if (event.origin !== window.location.origin) {
			return;
		}
		const data = event.data as GoogleOAuthCallbackMessage;
		if (data?.action === GOOGLE_OAUTH_CALLBACK_ACTION) {
			listener(data.payload);
		}
	};

	window.addEventListener('message', onWindowMessage);

	const channel = new BroadcastChannel(GOOGLE_OAUTH_CALLBACK_CHANNEL_ID);
	const onChannelMessage = (event: MessageEvent<GoogleOAuthCallbackMessage>) => {
		if (event.data?.action === GOOGLE_OAUTH_CALLBACK_ACTION) {
			listener(event.data.payload);
		}
	};
	channel.addEventListener('message', onChannelMessage);

	return () => {
		window.removeEventListener('message', onWindowMessage);
		channel.removeEventListener('message', onChannelMessage);
		channel.close();
	};
}
